<form [formGroup]="fgNote">
<div mat-dialog-title style="display:flex; flex-direction: row; flex-wrap: wrap;">
    <div><h3>Bulk Update - Not Lost Unit Faults</h3></div>
</div>

<div mat-dialog-content style="overflow: auto;">
    <div>
        The following faults did not result in a lost unit, enter an optional note and click "Update" to mark these as
        Reviewed - No Lost Units.
    </div>
    <div>
        <mat-table [dataSource]="faultListNoLostUnits" class="gea-mat-table" style="overflow:auto; height:300px;">

        <ng-container matColumnDef="ShiftDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Shift Date</mat-header-cell>
            <mat-cell *matCellDef="let d">{{d.shiftDate | date:'MM/dd/yyyy'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Shift">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Shift</mat-header-cell>
            <mat-cell *matCellDef="let d">{{d.shift}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Hour">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Hour</mat-header-cell>
            <mat-cell *matCellDef="let d">{{d.Hour}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Downtime">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Duration</mat-header-cell>
            <mat-cell *matCellDef="let d">{{formatDuration(d.Problem_time_amt)}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="FaultMessage">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Fault</mat-header-cell>
            <mat-cell *matCellDef="let d">
                <div class="faultMessage">
                    <div *ngIf="inData.objectType == 'GROUP'" class="faultSource">{{d.FaultObjectDescription}}</div>
                    <div>{{d.FaultMessage}}</div>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>          
        </mat-table>
    </div>

    <mat-divider></mat-divider>

    <div style="padding-top: 10px;">
            <mat-form-field appearance="fill" class="full-width-textarea">
                <mat-label>Note (Optional):</mat-label>
                <textarea matInput formControlName="note"></textarea>

            </mat-form-field>
        
    </div>

    <div *ngIf="isSaving">
          <mat-spinner>Loading...</mat-spinner>
    </div>
</div>

<div mat-dialog-actions>
    <button mat-raised-button [disabled]="isSaving" color="warn" type="submit" (click)="update()">Update All</button>
    <span class="spacer"></span>
    <button mat-raised-button [disabled]="isSaving" color="primary" (click)="close()">Cancel</button>
</div>
</form>